import axios from "axios";
import { API_URL } from "./apiConfig";

// Store tokens


export const saveTokens = (accessToken, refreshToken, expiresIn, refreshExpiresIn, updateToken) => {

    updateToken(accessToken);
    localStorage.setItem("refresh_token", refreshToken);
    localStorage.setItem("access_token_expiry", Date.now() + expiresIn * 1000);
    localStorage.setItem("refresh_token_expiry", Date.now() + refreshExpiresIn * 1000);
};

// Login function
export const login = async (email, password, updateToken) => {
        const formData = new URLSearchParams();
        formData.append("grant_type", "password");
        formData.append("username", email);
        formData.append("password", password);

        const response = await axios.post(`${API_URL}/token`, formData, 
            {headers: {
            "accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            },
        });
        const { access_token, refresh_token, expires_in, refresh_expires_in } = response.data;
        saveTokens(access_token, refresh_token, expires_in, refresh_expires_in, updateToken);
    };

export const register = async (email, password) => {
        const response = await axios.post(`${API_URL}/register`, { email, password });
        return response.data;
    }


    // Refresh access token
export const refreshAccessToken = async (navigate, updateToken, removeToken) => {
        const refreshToken = localStorage.getItem("refresh_token");
        if (!refreshToken) {
            LogoutUser(navigate);
        }
        try {
            const response = await axios.post(`${API_URL}/refresh`, { "refresh_token" : refreshToken });
            saveTokens(response.data.access_token, refreshToken, response.data.expires_in, localStorage.getItem("refresh_token_expiry"), updateToken);
            return response.data.access_token;
        } catch (error) {
            LogoutUser(navigate, removeToken);
        }
    };

export const checkRefreshToken = async (updateToken, removeToken) => {
        const refreshToken = localStorage.getItem("refresh_token");
        console.log("refresh token:", refreshToken);
        if (!refreshToken) {
            return false;
        }
        try {
            const response = await axios.post(`${API_URL}/refresh`, {"refresh_token" : refreshToken });
            saveTokens(response.data.access_token, refreshToken, response.data.expires_in, localStorage.getItem("refresh_token_expiry"), updateToken);
            return true;
        } catch (error) {
            removeToken();
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("refresh_token_expiry");
            localStorage.removeItem("access_token_expiry");
            return false;
        }
    };

    // Logout function
export const LogoutUser = (navigate, removeToken) => {
        removeToken();
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("access_token_expiry");
        localStorage.removeItem("refresh_token_expiry");
        if (navigate){
            navigate("/"); // Redirect to login page
        } else {
            window.location.href = "/"; // Redirect to login page
        }
    };
    


